var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-wrapper"},[_c('div',{staticClass:"settings"},[_c('email',{staticClass:"card",attrs:{"cardTitle":"Billing","tableData":_vm.billingList,"flag":1},on:{"getDetail":_vm.getDetail}}),_c('email',{staticClass:"card",attrs:{"cardTitle":"Audit","tableData":_vm.auditList,"flag":2},on:{"getDetail":_vm.getDetail}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }